// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"6fba8140","325":"b8b1203f","328":"bf8958c9","338":"ab7b9cb7","452":"c01701b1","587":"323ce148","609":"66983fbe","619":"58b37d6d","669":"eeed5844","793":"f3bb2f3e","820":"91bf1263","873":"46bf2a4b","928":"a3525461","990":"96c6b9a1"}[chunkId] + ".chunk.js";
};